/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, type: NonNullable<unknown> }} Seat_Price_Scheduled_MinimumInputs */



/**
* | output |
* | --- |
* | "On {date}, at your renewal, the empty seat becomes a {type} seat." |
*
* @param {Seat_Price_Scheduled_MinimumInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_price_scheduled_minimum = /** @type {((inputs: Seat_Price_Scheduled_MinimumInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Price_Scheduled_MinimumInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Am ${i?.date}, zu Ihrer Verlängerung, wird der freie Platz zu einem ${i?.type}-Platz.`)
	return /** @type {LocalizedString} */ (`On ${i?.date}, at your renewal, the empty seat becomes a ${i?.type} seat.`)
});